import nextI18nextConfig from '../next-i18next.config'

/**
 * @param route an app route such as `/cases`
 * @param locale the active i18n language
 * @returns the route with the locale prefix Next expects for non-default locales
 */
export const localizeRoute = (route: string, locale?: string): string => (
  locale && locale !== nextI18nextConfig.i18n.defaultLocale ? `/${locale}${route}` : route
)

/**
 * Next 12 follows a `getServerSideProps` redirect on client navigations without re-adding the locale,
 * so it has to be in the destination or the page falls back to the default language.
 * @param destination an app route such as `/developer/api-keys`
 * @param locale the request's locale from the `getServerSideProps` context
 * @returns a temporary redirect that keeps the request's locale
 */
export const localizedRedirect = (destination: string, locale?: string) => ({
  redirect: { destination: localizeRoute(destination, locale), permanent: false },
})
